import { emptyV2Api as api } from "../../../emptyV2Api";
import { PlanUploadJobItem } from "./planUploadJobItem";
import { UsimTypeItem } from "./usimTypeItem";

export const addTagTypes = ["ProductType"] as const;
const SLUG = "/usim/product-type"
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getProductTypes: build.query<UsimTypeItem[], void>({
        query: () => ({
          url: SLUG + "/manage?version=new",  // ← Remove 's' from products, remove /get
          method: "GET",                     // ← Change POST to GET
        }),
        providesTags: ["ProductType"],
      }),
      getSingleProductType: build.query<UsimTypeItem, string>({
        query: (productType) => ({
          url: SLUG + "/manage?version=new&type=" + productType,
          method: "GET",
        }),
        providesTags: ["ProductType"],
      }),
      getProductTypeUploadJobs: build.query<PlanUploadJobItem[], void>({
        query: () => SLUG + "/upload?version=new",
        providesTags: ["ProductType"],
      }),
      postProductType: build.mutation<UsimTypeItem, UsimTypeItem>({
        query: (productType) => ({
          url: SLUG + "/manage?version=new",
          method: "POST",
          body: productType,
        }),
        invalidatesTags: ["ProductType"],
      }),
      putProductType: build.mutation<UsimTypeItem, UsimTypeItem>({
        query: (productType) => ({
          url: SLUG + "/manage?version=new",
          method: "PUT",
          body: productType,
        }),
        invalidatesTags: ["ProductType"],
      }),
      putProductTypeStatus: build.mutation<UsimTypeItem, UsimTypeItem>({
        query: (productType) => ({
          url: SLUG + "/manage?version=new&status=" + productType.status,
          method: "PUT",
          body: productType,
        }),
        invalidatesTags: ["ProductType"],
      }),
      deleteProductType: build.mutation<UsimTypeItem, UsimTypeItem>({
        query: (productType) => ({
          url: SLUG + "/manage?version=new&id=" + productType.id,
          method: "DELETE",
        }),
        invalidatesTags: ["ProductType"],
      }),
    }),
  });

export const {
  useGetProductTypesQuery,
  useGetSingleProductTypeQuery,
  usePostProductTypeMutation,
  usePutProductTypeMutation,
  usePutProductTypeStatusMutation,
  useDeleteProductTypeMutation,
  useGetProductTypeUploadJobsQuery,
} = injectedRtkApi;
